import React from "react";

export const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col items-center text-white">
      <div className="container min-h-screen">
        <main className="flex flex-col items-center w-full py-4 px-4">
          <header className="lg:w-1/2 py-8 w-full">
            <a
                href="/"
              class="mb-4 text-black bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              style={{
                backgroundColor: '#DED4FF'
              }}
            >
              <img
                src="/images/home-1.png"
                className="w-6 h-6 mr-2"
                />
              Website
            </a>
            <h1 className="text-3xl font-medium mt-8">
              Privacy Policy - Wisdom App
            </h1>
          </header>

          <section className="lg:w-1/2">
            <h2 className="text-xl font-medium mt-12 mb-4">Introduction</h2>
            <p className="text-gray-400 mb-4">
              Our app, Wisdom, is committed to protecting your privacy. This
              Privacy Policy explains what personal information we collect, how
              we use it, and the choices you have associated with that
              information.
            </p>
          </section>

          <section className="lg:w-1/2">
            <h2 className="text-xl font-medium mt-12 mb-4">
              Information Collection and Use
            </h2>
            <p className="text-gray-400 mb-4">
              Wisdom does not collect any personal information from users. Our
              app does not require any registration, sign-up, or login.
            </p>
          </section>

          <section className="lg:w-1/2">
            <h2 className="text-xl font-medium mt-12 mb-4">
              Third-Party Services
            </h2>
            <p className="text-gray-400 mb-4">
              Our app does not use any third-party services that collect
              personal information.
            </p>
          </section>

          <section className="lg:w-1/2">
            <h2 className="text-xl font-medium mt-12 mb-4">
              Changes to this Policy
            </h2>
            <p className="text-gray-400 mb-4">
              We may update this Privacy Policy from time to time. If we make
              changes, we will post the updated policy on this page and indicate
              the date it was last revised at the top of the page. Your
              continued use of our app after any changes indicates your
              acceptance of the new policy.
            </p>
          </section>

          <section className="lg:w-1/2">
            <h2 className="text-xl font-medium mt-12 mb-4">
              Contact Information
            </h2>
            <p className="text-gray-400 mb-4">
              If you have any questions or concerns about this Privacy Policy,
              please contact us via <a href="mailto:hi.wisdomapp@gmail.com"
              style={{
                fontWeight: 600,
                borderBottom: '1px solid #7dd3fc'
              }}
              >hi.wisdomapp@gmail.com</a>
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};
